import React from 'react';
import { Link } from 'react-router-dom';
import yellowWoman from '../../assets/serptzLap.jpg';
import PTZImg from '../../assets/PTZ.png'; // Import images for each category
import switchImg from '../../assets/switchCsc.png';
import firewallImg from '../../assets/firewall.png';
import domeImg from '../../assets/dome.png';
import softwareImg from '../../assets/APC_UPS.png';
import accessControlImg from '../../assets/Access-Control-ATSS-removebg-preview.png';
import dataStorageImg from '../../assets/dataSolu.png';
import routerImg from  '../../assets/router.png'
// Import other images similarly...

const productCategories = [
  { name: "PTZ Camera", img: PTZImg },
  { name: "Cisco Switches", img: switchImg },
  { name: "Firewalls", img: firewallImg },
  { name: "Dome Camera", img: domeImg },
  {name: "UPS", img: softwareImg},
  {name: "Access Control", img: accessControlImg},
  {name: "Data Storage", img: dataStorageImg},
  {name: "Cisco Router", img: routerImg}
];

const Products = () => {
  return (
    <section className="py-16 w-cover"> {/* Slight increase in padding */}
      <div className="relative">
        <img src={yellowWoman} alt="Slide 3" className="w-full h-64 md:h-80 lg:h-96 object-cover" />
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 p-5">
          <h2 className="text-white text-4xl lg:text-6xl text-center font-semibold">
            PRODUCTS <br />
            <span className='text-gray-100 text-sm sm:text-base md:text-md lg:text-lg'>
              Transform Your Network with Cutting-Edge Solutions
            </span>
          </h2>
        </div> 
      </div>
      <div className="mt-8 lg:px-6 p-5">
        <h1 className="text-2xl font-semibold text-center mb-6">Popular Products</h1>
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6 justify-content"> {/* Added gap between items */}
          {productCategories.map((category, index) => (
            <div 
              key={index} 
              className="flex flex-col justify-between items-center w-4/5 sm:w-3/4 p-4 sm:p-6 bg-gray-50 border border-gray-200 rounded shadow hover:shadow-lg hover:bg-gray-200 transition-colors duration-200" // Reduced size and padding
            >
              <img 
                src={category.img} 
                alt={category.name} 
                className="w-full object-cover mb-2 rounded" // Reduced margin-bottom
              />
              <span className="text-lg font-medium text-gray-800 text-center h-12 flex items-center justify-center" style={{ minHeight: "3rem" }}>{category.name} </span>
            </div>
          ))}
        </div> <br />
        <div className="bg-white py-12">
        <div className="container mx-auto text-center">
          <h2 className="text-xl md:text-4xl font-semibold text-[#023B8D] mb-6 animate-bounce">
            Ready to Transform Your Business?
          </h2>
          <p className="text-gray-700 text-lg md:text-xl mb-8 animate-fadeIn delay-1s">
            Get in touch with us to start your digital transformation journey.
          </p>
          <Link to="/ContactPage">
            <button className="bg-[#C5B358] text-blue-900 font-semibold py-3 px-8 rounded-full transition duration-300 hover:bg-[#c39e2a] hover:scale-110 animate-pulse">
              Contact Us
            </button>
          </Link>
        </div>
        <style>{`
          @keyframes zoomInOut {
            0% {
              transform: scale(1);
            }
            100% {
              transform: scale(1.1);
            }
          }
        `}</style>
      </div>
      </div>
    </section>
  );
};

export default Products;
